module.exports = __webpack_public_path__ + "static/media/dubai-marina-mall.fcf10b9a.jpeg";